import { Grid } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { IOperationColumn } from '../../models/vessel-kpi'
import { TableCentralizedCell } from './TableCentralizedCell'

interface Props {
  children?: React.ReactNode
  column: IOperationColumn
  value?: number | string
  skipTotal?: boolean
}
export const VesselKpiTableCell = observer(({ children, column, value, skipTotal }: Props) => {
  const mdGrid = useMemo(() => {
    let total = skipTotal ? 0 : 1

    if (column.hasInbound) total++
    if (column.hasOutbound) total++
    if (column.hasRestow) total++

    return 12 / total
  }, [column, skipTotal])

  return (
    <Grid size={{ xs: 12, md: mdGrid }}>
      {value !== undefined && <TableCentralizedCell>{value}</TableCentralizedCell>}

      {children}
    </Grid>
  )
})
